import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin, Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { AlertService } from "src/app/services/alert.service";
import { ExpiryWarningService } from "src/app/services/expiry/expiry-warning.service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { MessagingService } from "../../messaging/messaging.service";
import { CommonService } from "../../services/common.service";
import { DateType, DATE_FORMATS } from "./../../services/utils";

@Component({
  selector: "app-draft-message",
  templateUrl: "./draft-message.component.html",
  styleUrls: ["./draft-message.component.scss"],
})
export class DraftMessageComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  draftCampList: any = [];
  campaignId: string = "None";
  itemsPerPage: number = 25;
  p: number = 1;
  totalDraftCount: number;
  DATE_FORMATS = DATE_FORMATS;
  pagePerItemList: any = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 75 },
    { value: 100 },
  ];
  channel: string = "";
  filterDate: any;
  public todayDate: any = new Date();
  permissions: any;
  isFilteredData: boolean = false;
  start: any;
  end: any;
  promotionInfo: string = "all";
  isAccessMenu: any;
  outlet_id: string;
  is_messaging_blocked: any;
  messaging_warning_text: any;
  startAt: DateType;
  searchText: string = "";
  private searchText$: Subject<string> = new Subject();

  promotionalChannels = [];
  transactionalChannels = [];
  allChannels = [];
  channelList = [];

  constructor(
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private httpService: DataService,
    private toastrService: ToastrService,
    private commonservice: CommonService,
    private router: Router,
    private alertService: AlertService,
    private messagingService: MessagingService,
    private expiryWarningService: ExpiryWarningService
  ) {}

  ngOnInit() {
    this.isAccessMenu = this.storage.get("access").main_menu;
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    // this.draftMessageList();
    this.getMessagingMetaData();
    this.commonservice.sent_message_tab_selection.subscribe((result) => {
      if (result === "SENTDRAFT") {
        this.reset();
      }
    });
    this.searchText$.pipe(debounceTime(500)).subscribe(() => {
      this.onFilter();
    });
    this.startAt = this.commonservice.onDateFilter();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkExpiry();
    }, 500);
  }
  checkExpiry() {
    let divContainer: HTMLElement | null = document.querySelector('#expiry-modal');
    const {isExpired, expiryWarningText} = this.expiryWarningService.checkExpiryBasedOnProduct('MESSAGING', divContainer);
    this.is_messaging_blocked = isExpired;
    this.messaging_warning_text = expiryWarningText;
  }
  public deleteBanner() {
    this.messaging_warning_text = "";
  }
  onSearch() {
    if (
      (this.searchText && this.searchText.length > 2) ||
      !this.searchText.length
    ) {
      this.onFilter();
      this.searchText$.next();
    }
  }

  downloadUploadedFile(post) {
    window.open(post.s3_url, "_blank");
    window.setTimeout(function () {
      this.close();
    }, 1000);
  }
  redirectToCustomerList(customerListId: string) {
    customerListId !== null &&
      this.messagingService.redirectToCustomerList(customerListId);
  }

  onPromotionInfoChange() {
    if (this.promotionInfo == "all") {
      this.channelList = [];
      this.channelList = this.commonservice.deepCloneArray(this.allChannels);
    } else if (this.promotionInfo == "transactional") {
      this.channelList = [];
      this.channelList = this.commonservice.deepCloneArray(
        this.transactionalChannels
      );
    } else {
      this.channelList = [];
      this.channelList = this.commonservice.deepCloneArray(
        this.promotionalChannels
      );
    }
    this.channel = "all";
    this.p = 1;
    this.draftMessageList();
  }

  reset() {
    this.p = 1;
    this.filterDate = undefined;
    this.start = undefined;
    this.end = undefined;
    this.channel = "";
    this.searchText = "";
    this.isFilteredData = false;
    this.promotionInfo = "all";
    this.channelList = [];
    this.channelList = this.commonservice.deepCloneArray(this.allChannels);
    this.draftMessageList();
  }
  onPageChange(event) {
    this.p = event;
    this.draftMessageList();
  }
  itemsPerPageChange() {
    this.onPageChange(this.p);
  }

  private getMessagingMetaData() {
    this.messagingService.getMessagingMetaDataAPI().subscribe((res) => {
      if (res.code == 200) {
        this.promotionalChannels = res?.data?.promotional_channels;
        this.transactionalChannels = res?.data?.transactional_channels;
        this.allChannels = res?.data?.all_channels;

        this.allChannels = this.allChannels.filter((element: any) => {
          return element?.value !== "Email";
        });

        this.promotionalChannels = this.promotionalChannels.filter(
          (element: any) => {
            return element?.value !== "Email";
          }
        );

        this.transactionalChannels = this.transactionalChannels.filter(
          (element: any) => {
            return element?.value !== "Email";
          }
        );

        if (this.promotionInfo == "all") {
          this.channelList = [];
          this.channelList = this.commonservice.deepCloneArray(
            this.allChannels
          );
        } else if (this.promotionInfo == "transactional") {
          this.channelList = [];
          this.channelList = this.commonservice.deepCloneArray(
            this.transactionalChannels
          );
        } else {
          this.channelList = [];
          this.channelList = this.commonservice.deepCloneArray(
            this.promotionalChannels
          );
        }

        this.draftMessageList();
      }
    });
  }

  private draftMessageList() {
    let res: Response;
    const draft_campaign = this.httpService.getRequest({
      // customApiUrl: this.BASE_URL.MESSAGING_SMS_DRAFT_FILTER_V2(this.outlet_id),
      customApiUrl: this.BASE_URL.MESSAGING_DRAFT_FILTER(
        this.outlet_id,
        this.promotionInfo
      ),
      page: this.p.toString(),
      size: this.itemsPerPage.toString(),
      start: this.start ? this.start : null,
      end: this.end ? this.end : null,
      channel: this.channel && this.channel !== "all" ? this.channel : null,
      keyword: this.searchText || null,
    });
    draft_campaign.subscribe((data: Response) => {
      res = data;
      this.draftCampList = res.data["messages"];
      this.permissions = res.data["permissions"];
      this.totalDraftCount = res.data["total_draft_message_count"];
      this.messagingService.setTotalCount({
        count: this.totalDraftCount,
        type: "DRAFT",
        product: "TRANSACTIONAL",
      });
      this.loading = false;
    });
  }

  onEditMessage(messageId: string) {
    console.log(messageId);
    this.commonservice.onCampaignEdit.next(messageId);
    this.router.navigate([`/messaging/edit/${messageId}`]);
  }

  onFilter() {
    this.isFilteredData = true;
    this.p = 1;
    if (this.filterDate) {
      this.start = moment(this.filterDate[0]).format("YYYY-MM-DD");
      this.end = moment(this.filterDate[1]).format("YYYY-MM-DD");
    }

    this.draftMessageList();
  }

  deleteDraftList(campaignid) {
    this.campaignId = campaignid;
    // this.modalService.open(deleteModel);
    this.alertService
      .alertWithDeleteImage(
        "Delete Draft Message",
        "Are you sure you want to delete draft message?",
        "Delete"
      )
      .then((data) => {
        if (data.isConfirmed) {
          this.deleteDraft();
        }
      });
  }

  deleteDraft() {
    let res: Response;
    this.messagingService.deleteDraftMessage(this.campaignId).subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.modalService.dismissAll();
          this.toastrService.success(res.data["message"]);
          this.draftMessageList();
        }
      }
    );
  }
}
